export default __webpack_public_path__ + "static/media/green-tick.94ea6b60.svg";